// extracted by mini-css-extract-plugin
module.exports = {"root":"_2OzJ","card":"_1Bfw","line":"TUdV"};